var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('breadcrumb',{attrs:{"breadcrumb":_vm.breadcrumb}}),_vm._v(" "),_c('table-main',{attrs:{"selection":false,"hasOperation":false,"tableHead":_vm.tableHead,"tableData":_vm.tableData,"total":_vm.total,"pageNum":_vm.pageNum,"pageSize":_vm.pageSize},on:{"changePagination":_vm.changePagination}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2675fc3e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/AlarmManage/PoliceStatistics/StatisticsByDate.vue
// module id = null
// module chunks = 